<template>
  <div class="card-container">
    <div class="card-content">
      <div class="relative">
        <h4>Check out our blog!</h4>
        <img
          src="../../assets/blog-card-underline.svg"
          class="absolute -bottom-2 left-0 w-full"
        />
      </div>
      <p>
        Get the latest scoop on gifting, tips & guides for making every custom
        merchandise memorable!
      </p>
      <button
        @click="goToBlog"
        class="whitebutton-gemnote button-gemnote-glass--tiny gray"
      >
        <span>GO TO BLOG</span>
      </button>
    </div>
    <div class="card-image">
      <img
        src="../../assets/blog-card-img.png"
        class="w-full h-full object-fill"
      />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goToBlog() {
      window.open('https://gemnote.com/blog', '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.whitebutton-gemnote--small {
  font-size: 0.813rem;
  font-weight: normal;
  height: 2.5rem;
  width: max-content !important;
  padding: 0 0rem !important;
}

.button-gemnote-glass--tiny {
  width: max-content !important;
  font-weight: 400 !important;
  padding: 0 1rem !important;
}

.card-container {
  display: grid;
  grid-template-columns: 57% 43%;
  background-color: #232220;
  border-radius: 6px;
  border: 0.5px solid #232220;
  height: 100%;

  .card-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    border-right: 0.5px solid #f5f2ee;
    padding: 1rem;
    padding-left: 1.5rem;
    h4 {
      text-align: left;
      font-size: 1rem;
      font-family: $editorial;
      font-weight: normal;
      color: #f5f2ee;
    }
    p {
      color: #f5f2ee;
      font-size: 0.568rem;
      text-align: left;
      margin: 1rem 0;
      font-weight: 300;
    }
  }
  .card-image {
    padding: 0.4rem;
  }
}

@media (max-width: 854px) {
  .card-container {
    .card-content {
      padding-left: 1rem;
    }
  }
}
@media (min-width: 2100px) {
  .card-container {
    .card-content {
      gap: 1rem;
    }
  }
}
</style>
